import React, { useEffect, useState } from 'react';
import CandidateDashboardNav from '../../candidate/CandidateDashboardNav';
import MyResume from '../../candidate/MyResume';
import CreateResume from '../../candidate/CreateResume';
import MyResumeEdit from '../../candidate/MyResumeEdit';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { useCallback } from 'react';
import Breadcrumb from '../../Breadcrumb';

const CandidateResume = () => {
  const [loading, setLoading] = useState(true);
  const [myResume, setMyResume] = useState(null);
  const [availability, setAvailability] = useState(false);
  const [editMode, setEditMode] = useState(false);
  // const [showButtons, setShowButtons] = useState(false);
  const [error, setError] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");

  const getResumeByUserId = useCallback(async () => {
    if (!userid || availability) return;
    setLoading(true);
    setError(null);
    try {
      const url = `${process.env.REACT_APP_API_URL}resume/getresumebyuser/${userid}`;
      const response = await axios.get(url);

      if (response.data.length > 0) {
        const fetchedResume = response.data[0];
        setMyResume(fetchedResume);
        setAvailability(true);
        localStorage.setItem('myResume', JSON.stringify(fetchedResume)); 
       
      } else {
        setAvailability(false);
        setMyResume(null);
      }
    } catch (error) {
      setError("Failed to load resume data. Please try again later.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [userid, availability]);

  useEffect(() => {
    getResumeByUserId();
  }, [getResumeByUserId]);

  const deleteResume = async (resume_id) => {
    if (!resume_id) {
      setError('Invalid resume ID. Please refresh and try again.');
      return;
    }
    setDeleting(true);
    setError(null);
    try {
      const url = process.env.REACT_APP_API_URL + `resume/delete-resume`;
      await axios.put(url, { resume_id, userid });
      setMyResume(null);
      setAvailability(false);
      localStorage.removeItem('myResume'); // Clear cache
      setEditMode(false);

    } catch (error) {
      setError("Failed to load resume data. Please try again later.");
      console.error(error);
    } finally {
      setDeleting(false);
    }
  };


  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center my-4">
  //       <div className="spinner-border text-primary" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }

  // Error message
  // if (error) {
  //   return (
  //     <div className="alert alert-danger text-center my-4" role="alert">
  //       {error}
  //     </div>
  //   );
  // }

  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">My Resume</h2>
          <ul className="breadcrumb-menu">
            <li><a href="/">Home</a></li>
            <li className="active">My Resume</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="My Resume"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "My Resume", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <CandidateDashboardNav />

              {/* Lazy-loaded components */}
              <React.Suspense
              fallback={
                <div className="d-flex justify-content-center my-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              }
            >
            {availability && !editMode && <MyResume userid={userid} />}
            {!availability && <CreateResume />}
            {editMode && <MyResumeEdit myResume={myResume} />}
            </React.Suspense>
            {
              availability && (
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn btn-warning mx-2"
                    onClick={() => setEditMode(!editMode)}
                  >
                    <i className="fa-solid fa-edit me-1"></i>{' '}
                    {editMode ? 'Cancel Edit' : 'Edit Information'}
                  </button>
              <button
                className={`btn btn-danger mx-2 ${deleting ? 'disabled' : ''}`}
                onClick={() => deleteResume(myResume?.resume_id)}
                disabled={deleting}
              >
                {/* <i className="fa-solid fa-trash-alt me-1"></i> Delete
              </button> */}
              {deleting ? (
                    <span className="spinner-border spinner-border-sm me-1"></span>
                  ) : (
                    <i className="fa-solid fa-trash-alt me-1"></i>
                  )}
                  Delete
                </button>
              <button
                className="btn btn-primary mx-2"
                onClick={() => window.print()}
              >
                <i className="fa-solid fa-print me-1"></i> Print
              </button>
            </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateResume;
